<div class="am-bag-status-content" [ngSwitch]="statusBag">
  <span *ngSwitchCase="StatusBag.PAID">{{'bagsSelectionCarryon.bag-status.none' | translate}}</span>
  <span *ngSwitchCase="StatusBag.DOCUMENT" class="opacity-75">{{'bagsSelectionCarryon.bag-status.document' | translate}}</span>
  <span *ngSwitchCase="StatusBag.INCLUDE" class="opacity-75">{{'bagsSelectionCarryon.bag-status.include' | translate}}</span>
  <div *ngSwitchCase="StatusBag.TO_PAY" class="am-bag-status-block">
    <strong>{{totalAmount | amCurrency:'':'symbol':'0.0'}}</strong>
    <span>{{currencyCode}}</span>
  </div>
</div>

